import { AxiosResponseHeaders } from 'axios';
import { CardTransactionDetails, CardTransactionDetailsResponseDTO } from '../entities/CardTransaction';

export const cardTransactionDetailsResponseDTOtoCardTransactionDetailsAdapter = (
  data: CardTransactionDetailsResponseDTO,
  header?: AxiosResponseHeaders,
): CardTransactionDetails => {
  if (!data.body) {
    throw new Error();
  }

  const {
    creationDate,
    postingDate,
    merchantName,
    merchantType,
    status,
    rrn,
    amount,
    currencyShortDescription,
    countryCode,
    transactionValue,
    transactionValueCurrencyShortDescription,
    cardNumber,
  } = data.body;

  return new CardTransactionDetails(
    creationDate,
    postingDate,
    merchantName,
    merchantType,
    status,
    rrn,
    amount,
    currencyShortDescription,
    countryCode,
    transactionValue,
    transactionValueCurrencyShortDescription,
    cardNumber,
  );
};
